export class SubclinicalSubject {
    id = null;
    name = null;
    code = null;
    description = null;
}